import { useQuery } from "react-query";
import { getPendingTermination } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetPendingTerminationReport = () => {
  return useQuery("GetPendingTerminationReport", getPendingTermination, {
    refetchOnWindowFocus: false,
  });
};
export default useGetPendingTerminationReport;
